export const Easing = {
    bezier: {
        outNormal: [0.18, 1.01, 0.46, 0.98] as [number, number, number, number],
    },
};
